import { BRAND_NAME } from "@/config/brand";

const DEFAULT_API_BASE_URL = "/api/v1/app";
const DEFAULT_ASSET_BASE_URL = "https://athome-1410572293.cos.ap-nanjing.myqcloud.com";
const TEST_LOGIN_HOSTS = new Set(["test.athomeflow.cn"]);

const trimTrailingSlash = (value: string) => value.replace(/\/+$/, "");
const isTruthyFlag = (value: string | undefined) => /^(1|true|yes|on)$/i.test((value || "").trim());
const resolveRuntimeHostname = () =>
  typeof window === "undefined" ? "" : window.location.hostname.toLowerCase();

export const env = {
  appName: BRAND_NAME,
  apiBaseUrl: trimTrailingSlash(
    (import.meta.env.VITE_API_BASE_URL as string | undefined) || DEFAULT_API_BASE_URL,
  ),
  assetBaseUrl: trimTrailingSlash(
    (import.meta.env.VITE_ASSET_BASE_URL as string | undefined) || DEFAULT_ASSET_BASE_URL,
  ),
  h5BasePath: (import.meta.env.BASE_URL as string | undefined) || "/",
  isDev: Boolean(import.meta.env.DEV),
  enableTestPhoneLogin:
    Boolean(import.meta.env.DEV) ||
    isTruthyFlag(import.meta.env.VITE_ENABLE_TEST_LOGIN as string | undefined) ||
    TEST_LOGIN_HOSTS.has(resolveRuntimeHostname()),
  debugLoginMobile: (import.meta.env.VITE_DEBUG_LOGIN_MOBILE as string | undefined) || "",
  debugLoginCaptcha: (import.meta.env.VITE_DEBUG_LOGIN_CAPTCHA as string | undefined) || "",
  debugLoginTerminal: (import.meta.env.VITE_DEBUG_LOGIN_TERMINAL as string | undefined) || "h5",
};

export const buildApiUrl = (path: string) => {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${env.apiBaseUrl}${normalizedPath}`;
};

export const buildAssetUrl = (path: string) => {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${env.assetBaseUrl}${normalizedPath}`;
};
